import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table as MuiTable
} from '@material-ui/core';

export const getReadableValue = (value: string) =>
  value
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camelCase or PascalCase
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/Seling/, 'Selling') // Fix common typos
    .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter

export interface TableData {
  value: string;
  unit: string;
  label: string;
}

interface TableProps {
  values: { [key: string]: TableData }[];
}

export const Table = ({ values }: TableProps) => (
  <TableContainer>
    <MuiTable size="small">
      <TableHead>
        <TableRow>
          {Object.keys(values[0]).map(key => (
            <TableCell key={key}>{values?.[0]?.[key].label}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {values.map((row, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <TableRow key={index}>
            {Object.keys(row).map(key => (
              <TableCell key={key}>
                {getReadableValue(row[key].value)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </MuiTable>
  </TableContainer>
);
